var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("section", { staticClass: "section-disinfection" }, [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-lg-6 offset-lg-3" },
          [_c("request-form", { attrs: { serviceId: 24 } })],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "section",
      { staticClass: "section-padding section-padding-gray" },
      [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-md-2" }, [_vm._v(" ")]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-8 col-12" }, [
            _c("h2", [_vm._v("บริการพ่นฆ่าเชื้อโรค บริการใหม่จาก BeNeat")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ให้ทุกพื้นที่ในบ้านของคุณปลอดภัยจากเชื้อโรคตัวร้าย ด้วยบริการฉีดพ่นกำจัดเชื้อโรค ไวรัส แบคทีเรีย และเชื้อรา จากสารสกัดจากธรรมชาติที่ BeNeat คัดสรรมาเป็นอย่างดี สามารถกำจัดเชื้อโรคได้ถึง 99.99% การันตีด้วยรางวัลมากมายทั้งในและต่างประเทศมากมายและได้รับ"
              ),
              _c("span", { staticClass: "text-success" }, [
                _vm._v("มาตรฐานทั้ง FDA (อย.) มอก. ECOCERT, NSF, SGS ฉลากเขียว")
              ])
            ]),
            _vm._v(" "),
            _c("h2", [
              _c("span", { staticClass: "text-success" }, [
                _vm._v("ในราคาเริ่มต้นเพียง 2,140 บาทเท่านั้น")
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("span", { staticClass: "text-orange" }, [
                _vm._v(
                  "*อัตราค่าบริการจะคิดตามพื้นที่ เปิดให้บริการเฉพาะกรุงเทพและปริมณฆลนะคะ"
                )
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _c("b", [_vm._v("การพ่นน้ำยากำจัดเชื้อโรค")]),
              _vm._v(
                " คือ การให้บริการฉีดพ่นน้ำยากำจัดเชื้อแบคทีเรีย เชื้อรา และไวรัส ด้วยทีมงานมืออาชีพที่มาพร้อมกับเครื่องพ่นน้ำยาฆ่าเชื้อพิเศษที่นำเข้ามาจากต่างประเทศ สามารถพ่นละอองฝอยได้เล็กถึง 10 ไมครอน สามารถจับกับเชื้อโรคได้อย่างมีประสิทธิภาพและไม่ทำให้ผนัง พื้นผิว วัสดุ ตลอดจนเฟอร์นิเจอร์ของคุณเสียหาย แต่หากละอองนั้นใหญ่เกินไปจะไม่สามารถเกาะกับพื้นผิวได้นานและไม่ทั่วถึงทำให้การกำจัดเชื้อโรคนั้นได้ผลได้ไม่ดีค่ะ"
              )
            ]),
            _vm._v(" "),
            _c("h3", [
              _c("span", { staticClass: "text-success" }, [
                _vm._v("Germ killer Bio Disinfectant")
              ])
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "น้ำยาฆ่าเชื้อโรค แบคทีเรีย เชื้อรา เชื้อไวรัสได้ถึง 99.99%"
              )
            ]),
            _vm._v(" "),
            _c("p", [_vm._v("ผลิตภัณฑ์ของบริษัท คีนน์ จำกัด")]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "ได้รับการรับรองจากสถาบันวิจัยชั้นนำทั้งในประเทศและระดับสากล"
              )
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "สามารถย่อยสลายได้เองตามธรรมชาติ โดยไม่ส่งผลกระทบต่อระบบนิเวศน์ และสิ่งแวดล้อม ฉีดพ่นแล้วเช็ดออกไม่เป็นอันตรายทั้งต่อคน และสัตว์เลี้ยง ประกอบด้วยสารสกัดจากพืช และสารประกอบออกไซด์ สามารถขจัดคราบเลือด คราบไขมัน คราบที่เกิดจากเชื้อรา และคราบตะกรันที่เกิดจากสารอินทรีย์ได้ดี ช่วยย่อยสลายของเสียได้อย่างรวดเร็ว ในขณะเดียวกันยังสามารถดับกลิ่นได้ไปในเวลาเดียวกัน ย่อยสลายได้เองตามธรรมชาติ และไม่ส่งผลกระทบต่อสิ่งแวดล้อม เป็นน้ำยาฆ่าเชื้อโรคคุณภาพสูงที่ได้รับการยอมรับในระดับสากล ใช้กันอย่างแพร่หลายในหน่วยงานราชการ และแม้แต่"
              ),
              _c("b", [_vm._v("สายการบินชั้นนำยังเลือกใช้")]),
              _vm._v("เพื่อกำจัดเชื้อโรคภายในห้องโดยสารอีกด้วยค่ะ")
            ]),
            _vm._v(" "),
            _c("div", [
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_11h07_54-e1586327629501-640x221.png",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                staticClass: "img-fluid",
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_11h08_08-640x202.png",
                  alt: ""
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "mt-4" }, [
              _c("h4", { staticClass: "text-orange" }, [
                _vm._v("มาตรฐานรับรอง")
              ]),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_21-e1586330396164.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h48_05-150x150.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/SGS_logo_logotype-e1586329536913.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/unnamed-1-e1586330171470.jpg",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/unnamed-e1586330204656.jpg",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_47-e1586330237905.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/2563-04-08_13h46_59-e1586330261438.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/unnamed-e1586330271913.png",
                  height: "120",
                  alt: ""
                }
              }),
              _vm._v(" "),
              _c("img", {
                attrs: {
                  src:
                    "https://story.beneat.co/wp-content/uploads/2020/04/nsf-logo-e1586330459934.png",
                  height: "120",
                  alt: ""
                }
              })
            ])
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-2" }, [_vm._v(" ")])
        ])
      ]
    )
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f40147dc", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f40147dc","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/serviceRequest/DisinfectantCleaning.vue
// module id = 2034
// module chunks = 0